module.exports = __webpack_public_path__ + "img/total-5.5e1ceb93.png";